const CategoryTreeEndpoints = {
  GET_CATEGORY_TREES: "/category-trees/",
  GET_CATEGORY_TREES_BY_WORKSPACE: (workspaceId: string) => `/category-trees/?workspace_id=${workspaceId}`,
  GET_LANDING_PATHS_BY_WORKSPACE: (workspaceId: string) => `/category-trees/landing-paths/?workspace_id=${workspaceId}`,
  GET_CATEGORY_TREE: (categoryTreeId: string) => `/category-trees/${categoryTreeId}/`,
  UPLOAD: "/category-trees/upload/",
  DOWNLOAD: (categoryTreeId: string) => `/category-trees/${categoryTreeId}/download/`,
};

export default CategoryTreeEndpoints;
